import {Button} from '@chekinapp/ui';
import styled from 'styled-components';
import {DEVICE} from '@chekin/guestapp-ui-kit';

export const PageWrapper = styled.div`
  width: 100%;
  height: 100vh;
  overflow-y: auto;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1280px;
  margin: 0 auto;
  position: relative;
  padding: 0 20px 65px;
  height: calc(100% - 64px);
  overflow-y: auto;
  z-index: 1;
  align-items: start;

  @media (min-width: ${DEVICE.laptop}) {
    padding: 0 80px;
  }
`;

export const HeaderWrapper = styled.div`
  width: 100%;
  z-index: 5;
  display: block;
  position: sticky;
  top: 0;
  height: 64px;
  background: ${({theme}) =>
    theme.hasTemplate ? theme.colors.navigationMenu.backgroundMenu : theme.colors.$p6};
  box-shadow: 0 2px 10px 0 rgba(147, 150, 174, 0.25);
`;

export const Container = styled.div`
  margin: auto;
  display: flex;
  width: 100%;
  align-items: center;
  height: 100%;
  padding: 0 15px;
  background: ${({theme}) =>
    theme.hasTemplate ? theme.colors.navigationMenu.backgroundMenu : theme.colors.$p6};
  @media (min-width: ${DEVICE.laptop}) {
    padding: 0 64px;
  }
`;

export const HeaderTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.36px;
  text-align: left;
  width: 100%;
  color: ${({theme}) =>
    theme.hasTemplate ? theme.colors.navigationMenu.menuItemsText : theme.colors.$p10};
`;

export const LogoContainer = styled.div`
  display: flex;

  & img {
    margin-right: 16px;
    width: 48px;
    height: 48px;
    object-fit: contain;
    border-radius: 50%;
  }
`;

export const Title = styled.div`
  width: 200px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  @media (min-width: ${DEVICE.laptop}) {
    width: 100%;
  }
`;

export const ContainerFooter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: fixed;
  width: 100%;
  bottom: 0;
  right: 0;
  left: 0;
  height: 64px;
  border-top: 1px solid rgba(21, 41, 70, 0.2);
  padding: 24px;
  gap: 24px;
  z-index: 5;
  background: ${({theme}) => theme.colors.$p5};

  @media (min-width: ${DEVICE.laptop}) {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    padding: 24px 64px;
    gap: 48px;
    z-index: 2;
  }
`;

export const StyledButton = styled(Button)`
  font-weight: normal;
  font-size: 16px;
  color: ${({theme}) =>
    theme.hasTemplate ? theme.colors.branding.fontSecondary : theme.colors.$p2};

  path {
    fill: ${props =>
      props.theme.hasTemplate ? props.theme.colors.branding.fontSecondary : props.color};
  }
`;
